import { MenuVariant } from "@/types/menu.types"

type NavLink = {
  href: string
  label: string
  ariaLabel: string
  title: string
  className?: string
}

// All links for the main navigation
const allHomeLinks: NavLink[] = [
  {
    href: '/urgence',
    label: 'Urgence',
    ariaLabel: 'Page urgence',
    title: 'Une urgence ?',
  },
  {
    href: '/#services',
    label: 'Services',
    ariaLabel: 'Découvrez nos services',
    title: 'Découvrez nos services',
  },
  {
    href: '/#portfolio',
    label: 'Réalisations',
    ariaLabel: 'Découvrez nos dernières réalisations',
    title: 'Découvrez nos dernières réalisations',
  },
  {
    href: '/articles',
    label: 'Articles',
    ariaLabel: 'Consultez nos articles et conseils',
    title: 'Consultez nos articles et conseils',
  },
  {
    href: '/#contact',
    label: 'Contact',
    ariaLabel: 'Contactez-nous',
    title: 'Contactez-nous',
  },
]

// All links for the legal navigation
const allLegalLinks: NavLink[] = [
  {
    href: '/',
    label: 'Accueil',
    ariaLabel: "Page d'accueil",
    title: "Page d'accueil",
    className: 'text-[16px]',
  },
  {
    href: '/legal/mentions-legales',
    label: 'Mentions Légales',
    ariaLabel: 'Mentions Légales',
    title: 'Mentions Légales',
    className: 'text-[16px]',
  },
  {
    href: '/legal/politique-de-confidentialite',
    label: 'Politique de Confidentialité',
    ariaLabel: 'Poloitique de Confidentialité',
    title: 'Politique de Confidentialité',
    className: 'text-[16px]',
  },
  {
    href: '/legal/politique-de-cookies',
    label: 'Politique de Cookies',
    ariaLabel: 'Politique de Cookies',
    title: 'Politique de Cookies',
    className: 'text-[16px]',
  },
]

// --- 2. Define the configuration for each variant ---

type MenuConfig = {
  links: NavLink[]
  /** Fond sur lequel la barre est posée : pilote toute la colorimétrie. */
  tone: 'light' | 'dark'
  showCta?: boolean
}

// This map contains all logic. It's easy to add new variants here.
export const menuConfig: Record<MenuVariant, MenuConfig> = {
  main: {
    links: allHomeLinks,
    tone: 'dark',
    showCta: true,
  },
  legal: {
    links: allLegalLinks,
    tone: 'light',
    showCta: false,
  },
  urgency: {
    links: allHomeLinks,
    tone: 'dark',
    showCta: true,
  },
  seo: {
    links: allHomeLinks,
    tone: 'light',
    showCta: true,
  },
}
